import { render, staticRenderFns } from "./TemplateManagement.vue?vue&type=template&id=4b9d41d6&scoped=true&"
import script from "./TemplateManagement.vue?vue&type=script&lang=js&"
export * from "./TemplateManagement.vue?vue&type=script&lang=js&"
import style0 from "./TemplateManagement.vue?vue&type=style&index=0&id=4b9d41d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d41d6",
  null
  
)

export default component.exports